import BaseApi from '../baseApi';

export default class CorbanbApi extends BaseApi {
  constructor(obj){
      obj = obj || {};
      super(obj);
  }

  add(corban) {
    corban = corban || {};

    return new Promise((resolve, reject) => {  
      return this.api
        .post('/correspondents', corban)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  update(corban) {
    corban = corban || {};

    return new Promise((resolve, reject) => {
      return this.api
        .put(`/correspondents/${corban.id}`, corban)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findAll() {
    return new Promise((resolve, reject) => {
      return this.api
        .get('/correspondents')
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findId(id) {
    id = id || {};

    return new Promise((resolve, reject) => {
      return this.api
        .get(`/correspondents/${id}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  addIndicated(indicatorId, correspondent) {
    correspondent = correspondent || {};

    return new Promise((resolve, reject) => {
      return this.api
        .post(`/correspondents/${indicatorId}/indicated`, correspondent)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findIndicated(indicatorId) {
    return new Promise((resolve, reject) => {
      return this.api
        .get(`/correspondents/${indicatorId}/indicated`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findIndicators() {
    return new Promise((resolve, reject) => {
      return this.api
        .get(`/correspondents/indicators`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }
}
